import type { UseQueryResult } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import {
  type DocumentRequestResponse,
  getAccountDocuments,
} from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAccountDocumentUploads = ({
  accountId,
  options,
}: {
  accountId?: string;
  options?: QueryOptions<DocumentRequestResponse[]>;
}): UseQueryResult<DocumentRequestResponse[]> => {
  return useRequest(
    queryKeys.documents.uploads(accountId || ""),
    () => getAccountDocuments(accountId || ""),
    {
      ...options,
    },
  );
};
